import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  Signal,
  untracked,
} from "@angular/core";
import { Router } from "@angular/router";
import { DialogsService } from "app/shared/services/dialogs/dialogs.service";
import { ArticleInfos } from "../../../features/articles/models/article.model";
import { ArticlesInfosFacadeService } from "app/features/articles/services/article-infos/article-infos-facade.service";
import { DocLocalComponent } from "../../../features/documents/containers/doc-local/doc-local.component";
import { SharedModule } from "../../shared.module";
import { NgClass } from "@angular/common";
import { BioLogoComponent } from "../bio-logo/bio-logo.component";
import { BigButtonComponent } from "../big-button/big-button.component";
import { ChipsComponent } from "../../modules/chips/chips.component";
import { PopoverModule } from "../../modules/popover/popover.module";
import { JustLogoComponent } from "../just-logo/just-logo.component";

@Component({
  selector: "vl-article-card",
  standalone: true,
  imports: [
    DocLocalComponent,
    SharedModule,
    NgClass,
    BioLogoComponent,
    BigButtonComponent,
    ChipsComponent,
    PopoverModule,
    JustLogoComponent,
  ],
  templateUrl: "./article-card.component.html",
  styleUrls: ["./article-card.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleCardComponent {
  facade = inject(ArticlesInfosFacadeService);

  articleId = input<string>();
  articleInfos = input<ArticleInfos>();

  article: Signal<ArticleInfos> = computed(() => {
    if (this.articleId()) {
      return this.facade.getByArticleId(this.articleId())();
    } else {
      return this.articleInfos();
    }
  });

  white = input(false);
  big = input(false);
  ref = input(true);
  noAction = input(false);
  infoStocks = input(false);
  image = input(true);
  showIcon = input(true);

  specifEnCours: boolean;
  specifEnValidation: boolean;
  photo: string;

  noLot: boolean = null;
  noPdc: boolean = null;

  constructor(
    private router: Router,
    private dialogs: DialogsService,
  ) {
    effect(() => {
      if (this.articleId()) {
        untracked(() => {
          this.onVisible();
        });
      }
    });
  }

  async onVisible() {
    this.specifEnValidation = null;
    this.specifEnCours = null;
    this.photo = null;

    if (this.article() && this.infoStocks()) {
      this.noLot =
        this.article()?.withLot !== undefined &&
        this.article()?.withLot !== null
          ? !this.article()?.withLot
          : null;
      this.noPdc =
        this.article()?.withPiedDeChaine !== undefined &&
        this.article()?.withPiedDeChaine !== null
          ? !this.article()?.withPiedDeChaine
          : null;
    }
  }

  goToArticle() {
    this.router.navigateByUrl(`/specification/id/${this.article()?.articleId}`);
  }

  goToComptage() {
    this.router.navigate([`/articles/inventory`], {
      queryParams: { articleId: this.article()?.articleId },
    });
  }

  onStats() {
    this.facade.onStats(
      this.article()?.articleId ??
        this.articleInfos()?.articleId ??
        this.articleId(),
    );
  }

  onStock() {
    this.router.navigate([`/stock/id/`], {
      queryParams: {
        articleId:
          this.article()?.articleId ??
          this.articleInfos()?.articleId ??
          this.articleId(),
      },
    });
  }
}
